import { render, staticRenderFns } from "./Exercise.vue?vue&type=template&id=3c96ed03&scoped=true&"
import script from "./Exercise.vue?vue&type=script&lang=js&"
export * from "./Exercise.vue?vue&type=script&lang=js&"
import style0 from "./Exercise.vue?vue&type=style&index=0&id=3c96ed03&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c96ed03",
  null
  
)

export default component.exports